import React from 'react'
import { CloseIcon, SearchIcon } from '@components/Icons'
import { colors } from '@lib/colors'
import { Pressable, StyleSheet, Text, TextInput, View } from 'react-native'
import Show from '@components/Show'
import { i18n } from '@lib/i18n'

const COPY = i18n.en.WORK_ORDERS.LIST.SEARCH

interface WorkOrderSearchbarProps {
  searchOpen: boolean
  toggleSearch: () => void
  searchString: string
  setSearchString: (value: string) => void
}

export default function (props: WorkOrderSearchbarProps) {
  const {
    searchOpen,
    toggleSearch,
    searchString,
    setSearchString,
  } = props

  return (
  <Show
    when={searchOpen}
    fallback={
      <SearchButton onOpen={ toggleSearch } />
    }
  >
    <SearchBar
      searchString={ searchString }
      onSearchStringChange={ (value: string) => setSearchString(value) }
      onClose={ toggleSearch }
    />
  </Show>
  )
}

/**
 *
 * Search button
 */
 interface SearchButtonProps {
  onOpen: () => void
}

const SearchButton = ({ onOpen }: SearchButtonProps) => {
  return (
    <Pressable style={ styles.topRightButton } onPress={ onOpen }>
      <Text style={ styles.searchButtonText }>{ COPY.BUTTON }</Text>
      <SearchIcon size={ 25 } color={ colors.blue[500] } />
    </Pressable>
  )
}

/**
 *
 * Search bar
 */
interface SearchBarProps {
  searchString: string,
  onSearchStringChange: (value: string) => void
  onClose: () => void
}

const SearchBar = ({ searchString, onSearchStringChange, onClose }: SearchBarProps) => {
  return (
    <>
      <Pressable style={ styles.topRightButton } onPress={ onClose }>
        <CloseIcon size={ 25 } color={ colors.gray[500] } />
      </Pressable>
      <View style={ styles.searchBarBorder }>
        <View style={ styles.searchBarInner }>
          <SearchIcon size={ 25 } color={ colors.gray[300] } />
          <TextInput
            placeholder={ COPY.PLACEHOLDER }
            style={ styles.searchBarInput }
            value={ searchString }
            onChangeText={ onSearchStringChange }
          />
        </View>
      </View>
      <Text style={ styles.searchSubtext }>{ COPY.SUBTEXT }</Text>
    </>
  )
}

const styles = StyleSheet.create({
  topRightButton: {
    position: 'absolute',
    top: 3,
    right: 0,
    flexDirection: 'row',
    alignItems: 'center',
  },

  // Search bar
  searchBarBorder: {
    backgroundColor: colors.gray[100],
    marginTop: 18,
    borderRadius: 21,
  },
  searchBarInner: {
    alignItems: 'center',
    backgroundColor: colors.white,
    borderRadius: 20,
    flexDirection: 'row',
    height: 40,
    paddingLeft: 16,
    paddingRight: 16,
    margin: 1,
  },
  searchBarInput: {
    alignItems: 'center',
    flex: 1,
    fontSize: 16,
    height: '100%',
    marginLeft: 10,
  },
  searchSubtext: {
    color: colors.gray[600],
    fontSize: 11,
    marginTop: 10,
    textAlign: 'center',
  },

  // Search button
  searchButtonText: {
    color: colors.blue[500],
    fontSize: 16,
    fontWeight: '600',
    marginRight: 8,
  },
})
